import { useEffect } from "react";
import { X } from "lucide-react";
import { motion } from "framer-motion";

// Simple image lightbox with backdrop + escape/click to close.
export default function Lightbox({ src, alt = "", onClose }) {
    useEffect(() => {
        const onKey = (e) => e.key === "Escape" && onClose();
        document.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden";
        return () => {
            document.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
        };
    }, [onClose]);

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="fixed inset-0 z-[70] flex items-center justify-center bg-brand-deep/90 p-6 backdrop-blur"
            onClick={onClose}
            data-testid="lightbox"
        >
            <button aria-label="Close" className="absolute right-6 top-6 flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20">
                <X className="h-6 w-6" />
            </button>
            <motion.img
                initial={{ scale: 0.92 }}
                animate={{ scale: 1 }}
                src={src}
                alt={alt}
                onClick={(e) => e.stopPropagation()}
                className="max-h-[85vh] max-w-full rounded-2xl object-contain shadow-brand-lg"
            />
        </motion.div>
    );
}
